import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'
import { OfflineBanner } from './components/site'
import { AuthProvider } from './lib/auth'
import { applyTheme } from './lib/theme'
import { ToastProvider } from './lib/toast'
import { initInstallPrompt, initPwa } from './pwa/register'
import { router } from './router'
import './styles/base.css'
import './styles/shells.css'
import './styles/festival.css'
import './styles/scholarships.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
})

applyTheme()
initInstallPrompt()
initPwa()

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('#root missing')

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ToastProvider>
          <RouterProvider router={router} />
          <OfflineBanner />
        </ToastProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
